import React, { useState, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import Table from '../../Table';
import Pagination from '../../TablePagination';
import StaffkeyIssue from './StaffkeyIssue';
import StaffkeyDelete from './StaffkeyDelete';
import { dateFormatter, roomsFormatter } from '../../../lib/formatter';

const StaffkeyList = ({
  staffId,
  staffRole,
  staffkeyListItems,
  reload,
  history,
}) => {
  const { t } = useTranslation();
  const [ isOpenStaffkeyIssueModal, setIsOpenStaffkeyIssueModal ] = useState(false);
  const [ isOpenStaffkeyDeleteModal, setIsOpenStaffkeyDeleteModal ] = useState(false);
  const [ paginationItem, setPaginationItem ] = useState({
    offset: 0,
    limit: 10,
  });
  const [ selectedStaffkeyId, setSelectedStaffkeyId ] = useState(null);
  const [ currentPageNumber, setCurrentPageNumber ] = useState(1);

  const staffkeyTypeFormatter = (type) => {
    return type === 'mobilekey' ? t('data.key_type.mobilekey') : t('data.key_type.cardkey');
  };

  const changePagination = (pageNumber) => {
    setCurrentPageNumber(pageNumber);
    setPaginationItem({
      ...paginationItem,
      offset: (pageNumber - 1) * paginationItem.limit,
    });
  };

  const selectStaffkeyDelete = (keyId) => {
    setSelectedStaffkeyId(keyId);
    setIsOpenStaffkeyDeleteModal(true);
  };

  return (
    <Fragment>
      <Table
        columns={[
          {
            key: 'grantee.name',
            text: t('data_column.staff'),
            width: '8%',
          },
          {
            key: 'grantor.name',
            text: t('data_column.grantor'),
            width: '7%',
            // grantor.id가 mf_staff_permission.id가 아니라 mf_staff.id로 나와서 조회할 수 없음.
            // linker: {
            //   func: (staffId) => history.push(`/staff/${staffId}`),
            //   params: ['grantor.id'],
            // },
          },
          {
            key: 'start_at',
            text: t('data_column.start_at'),
            width: '13%',
            formatter: {
              func: dateFormatter,
              params: ['start_at'],
            },
          },
          {
            key: 'end_at',
            text: t('data_column.end_at'),
            width: '13%',
            formatter: {
              func: dateFormatter,
              params: ['end_at'],
            },
          },
          {
            key: 'rooms',
            text: t('data_column.room'),
            width: '5%',
            formatter: {
              func: roomsFormatter,
              params: ['rooms'],
            },
          },
          {
            key: 'type',
            text: t('data_column.key_type'),
            width: '10%',
            formatter: {
              func: staffkeyTypeFormatter,
              params: ['type'],
            },
          },
          {
            key: 'card_no',
            text: t('data_column.card_no'),
            width: '8%',
          },
          {
            key: 'exchangekey',
            text: t('data_column.exchangekey'),
            width: '10%',
          },
          {
            key: 'seq_num',
            text: t('data_column.sequence'),
            width: '8%',
          },
          {
            key: 'created_at',
            text: t('data_column.created_at'),
            width: '13%',
            formatter: {
              func: dateFormatter,
              params: ['created_at'],
            },
          },
          {
            key: 'button',
            text: '',
            width: '5%',
            items: [
              {
                text: t('button.delete'),
                disabled: {
                  func: (type) => type !== 'mobilekey',
                  params: ['type'],
                },
                action: {
                  func: selectStaffkeyDelete,
                  params: ['id'],
                },
              },
            ],
          },
        ]}
        datas={staffkeyListItems}
      />
      <div className='form-item-add'>
        <button className='btn-item-add list' onClick={() => setIsOpenStaffkeyIssueModal(true)} hidden={staffRole === 'master'}>
          <FontAwesomeIcon icon={faPlusCircle} className='icon-item-add'/>
          <span>{t('button.key_issue')}</span>
        </button>
      </div>
      <Pagination
        total={staffkeyListItems.length}
        index={currentPageNumber}
        limit={paginationItem.limit}
        indexChange={changePagination}
      />
      <StaffkeyIssue
        isOpen={isOpenStaffkeyIssueModal}
        toggle={() => setIsOpenStaffkeyIssueModal(!isOpenStaffkeyIssueModal)}
        reload={reload}
        staffId={staffId}
      />
      <StaffkeyDelete
        isOpen={isOpenStaffkeyDeleteModal}
        toggle={() => setIsOpenStaffkeyDeleteModal(!isOpenStaffkeyDeleteModal)}
        reload={reload}
        keyId={selectedStaffkeyId}
      />
    </Fragment>
  );
};

export default StaffkeyList;